import { myLocalStorage } from '@/scripts/utils/storage/browser';

export const userStorage = myLocalStorage.getModule('user');
export const devStorage = myLocalStorage.getModule('dev');
export const STLocalStorage = myLocalStorage.getModule('serverTime');
